(function () {
  "use strict";

  /* CL-0086: head-type icon lookup must survive TRANSLATED option values on non-English
     storefronts. window.MC2_HEAD_ICONS (built in mc2-product-tabs.liquid) is keyed on the
     English drive-type names; on /fr the Head Type option value renders translated (e.g.
     "Slotted" -> "Fendue"), which missed the map and hid the icon on every affected card.
     mc2HeadKey() folds a known translated head value back to its English key before lookup.
     Only values that are actually translated need an entry; untranslated values already match
     the English keys. Add a line here whenever a Head Type value is translated into another
     published locale. */
  var MC2_HEAD_ALIAS = {
    "fendue": "slotted"
  };
  function mc2HeadKey(v) {
    v = (v || "").toString().trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(MC2_HEAD_ALIAS, v) ? MC2_HEAD_ALIAS[v] : v;
  }

  // CL-0087: locale flag for JS-rendered strings (the product count). <html lang> is "fr" on /fr.
  var MC2_IS_FR = (document.documentElement.getAttribute("lang") || "").toLowerCase().indexOf("fr") === 0;

  /* ---------------- product cards ---------------- */
  function initCard(card) {
    if (card.hasAttribute("data-mc2-init")) return;   // CL-0040: hydrate each card once
    card.setAttribute("data-mc2-init", "");
    var dataEl = card.querySelector("script[data-mc2-variants]");
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    if (!variants.length) return;

    var selects = Array.prototype.slice.call(card.querySelectorAll("select[data-option-position]"));
    var idInput = card.querySelector("[data-mc2-variant-id]");
    var priceEl = card.querySelector("[data-mc2-price]");
    var badge = card.querySelector("[data-mc2-badge]");
    var buyrow = card.querySelector("[data-mc2-buyrow]");
    var oos = card.querySelector("[data-mc2-oos]");
    var iconWrap = card.querySelector("[data-mc2-icon]");
    var iconImg = iconWrap ? iconWrap.querySelector("img") : null;
    var mediaImg = card.querySelector("[data-mc2-media]");
    var addBtn = card.querySelector('button[name="add"]');
    var qtyInput = card.querySelector("[data-mc2-qty]");
    var headPos = parseInt(card.getAttribute("data-headtype-position"), 10) || 0;
    var optionCount = variants[0].options.length;

    var IN = badge ? (badge.getAttribute("data-in") || "In stock") : "";
    var OUT = badge ? (badge.getAttribute("data-out") || "Not in stock") : "";

    function currentValues() {
      var vals = [];
      for (var pos = 1; pos <= optionCount; pos++) {
        var sel = null;
        for (var i = 0; i < selects.length; i++) {
          if (parseInt(selects[i].getAttribute("data-option-position"), 10) === pos) { sel = selects[i]; break; }
        }
        vals[pos - 1] = sel ? sel.value : variants[0].options[pos - 1];
      }
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (variants[i].options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function setIcon(vals) {
      if (!iconWrap || !iconImg) return;
      var staticIcon = card.getAttribute("data-static-icon"); // CL-0043: posts/extensions use a fixed part-type icon
      if (staticIcon) {
        iconImg.onerror = function () { iconWrap.hidden = true; };
        iconImg.src = staticIcon; iconWrap.hidden = false; return;
      }
      if (headPos < 1 || !window.MC2_HEAD_ICONS) { iconWrap.hidden = true; return; }
      var hv = mc2HeadKey(vals[headPos - 1]); // CL-0086: fold translated head values (e.g. "Fendue") to the English icon key
      var url = window.MC2_HEAD_ICONS[hv];
      if (url) {
        iconImg.onerror = function () { iconWrap.hidden = true; }; // hide if the icon asset is missing
        iconImg.src = url; iconImg.alt = vals[headPos - 1] + " head"; iconWrap.hidden = false;
      } else { iconWrap.hidden = true; }
    }

    function setMedia(v) {
      // image mode: swap to the matched variant's image when it has one
      if (!mediaImg || !v || !v.image) return;
      if (mediaImg.getAttribute("src") === v.image) return;
      mediaImg.srcset = "";            // drop the product-level srcset so the new src wins
      mediaImg.src = v.image;
    }

    function update() {
      var vals = currentValues();
      setIcon(vals);
      var v = findVariant(vals);
      var available = !!(v && v.available);

      setMedia(v);

      if (v) {
        if (idInput) { idInput.value = v.id; idInput.disabled = !available; }
        if (priceEl && typeof v.price === "string") { priceEl.textContent = v.price; }
      } else if (idInput) {
        idInput.disabled = true;
      }

      if (badge) { badge.textContent = available ? IN : OUT; badge.classList.toggle("is-out", !available); }
      if (buyrow) buyrow.hidden = !available;
      if (oos) oos.hidden = available;
      if (addBtn) addBtn.disabled = !available;
    }

    selects.forEach(function (s) { s.addEventListener("change", update); });

    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        var n = parseInt(qtyInput.value, 10);
        if (isNaN(n) || n < 1) qtyInput.value = 1;
        else qtyInput.value = n;
      });
    }

    update();
  }

  /* ---------------- part-type tabs (chrome pills) ---------------- */
  function initTabs(group) {
    var tabs = Array.prototype.slice.call(group.querySelectorAll("[role='tab']"));
    if (!tabs.length) return;
    var tabsRoot = group.closest(".mc2-product-tabs");

    function select(idx) {
      tabs.forEach(function (tab, i) {
        var selected = i === idx;
        tab.setAttribute("aria-selected", selected ? "true" : "false");
        tab.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute("aria-controls"));
        if (panel) { panel.hidden = !selected; panel.classList.toggle("is-active", selected); }
      });
      // CL-0036: clear the filter pills whenever the part-type tab changes
      if (tabsRoot) tabsRoot.dispatchEvent(new CustomEvent("mc2:tabchange"));
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () { select(i); });
      tab.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          var ni = (i + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
          select(ni);
          tabs[ni].focus();
        }
      });
    });

    var start = 0;
    tabs.forEach(function (tab, i) { if (tab.getAttribute("aria-selected") === "true") start = i; });
    select(start);
  }

  /* ---------------- collection filter pills (CL-0036; barrel added CL-0046) ----------------
     Facet-generic: reads the pressed pills, groups selected values by facet, and shows a card
     when it matches at least one selected value in EVERY active facet (AND across facets, OR
     within a facet). Filter attributes are server-rendered on each card, so this works before a
     card hydrates. */
    var MC2_FACET_ATTR = {
    length: "data-mc2-length",
    post: "data-mc2-post",
    barrel: "data-mc2-barrel",
    color: "data-mc2-color",
    threading: "data-mc2-threading",
    posttype: "data-mc2-posttype",
    headtype: "data-mc2-headtype"
  };
var MC2_FACET_ATTR_INSTOCK = { color: "data-mc2-color-instock" };

  // CL-0063: Length dropdown order (imperial then metric, ascending).
  var MC2_LEN_ORDER = ['1/16"','1/8"','3/16"','1/4"','5/16"','3/8"','7/16"','1/2"','5/8"','3/4"','7/8"','1"','1 1/4"','11/4"','1 1/2"','1 3/4"','2"','2 1/4"','2.3"','2 1/2"','2 3/4"','3"','3 1/4"','3 1/2"','3 3/4"','4"','4 1/2"','5"','5 1/2"','6"','7"','2mm','3mm','4mm','6mm','7mm','8mm','10mm','12mm','13mm','15mm','16mm','20mm','25mm','30mm','35mm','40mm','45mm','50mm','60mm','70mm','80mm'];

  function mc2DistinctValues(cards, attr) {
    var seen = {}, out = [];
    cards.forEach(function (c) {
      var raw = c.getAttribute(attr) || "";
      raw.split("|").forEach(function (v) {
        v = v.trim();
        if (v && !Object.prototype.hasOwnProperty.call(seen, v)) { seen[v] = 1; out.push(v); }
      });
    });
    return out;
  }

  // CL-0063: build the Length/Threading/Barrel dropdowns + Head-type icon toggles from
  // the cards' data attributes. A facet with < 2 distinct values in this tab stays hidden.
  function buildControls(row, cards) {
    [["length", MC2_FACET_ATTR.length], ["posttype", MC2_FACET_ATTR.posttype], ["threading", MC2_FACET_ATTR.threading], ["barrel", MC2_FACET_ATTR.barrel]].forEach(function (pair) {
      var facet = pair[0];
      var wrap = row.querySelector('[data-mc2-dropdown-for="' + facet + '"]');
      if (!wrap) return;
      var sel = wrap.querySelector("select");
      if (!sel || sel.options.length > 1) return; // already built
      var vals = mc2DistinctValues(cards, pair[1]);
      if (facet === "length") {
        vals.sort(function (a, b) {
          var ia = MC2_LEN_ORDER.indexOf(a), ib = MC2_LEN_ORDER.indexOf(b);
          if (ia < 0) ia = 999;
          if (ib < 0) ib = 999;
          return ia - ib || a.localeCompare(b);
        });
      } else {
        vals.sort(function (a, b) {
          var na = parseFloat(a), nb = parseFloat(b);
          if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
          return a.localeCompare(b);
        });
      }
      if (vals.length < 2) { wrap.hidden = true; return; }
      vals.forEach(function (v) {
        var o = document.createElement("option");
        o.value = v; o.textContent = v;
        sel.appendChild(o);
      });
      wrap.hidden = false;
    });

    var iconWrap = row.querySelector('[data-mc2-icons-for="headtype"]');
    if (iconWrap) {
      var host = iconWrap.querySelector('[data-mc2-icons="headtype"]');
      if (host && !host.childNodes.length) {
        var heads = mc2DistinctValues(cards, MC2_FACET_ATTR.headtype).sort();
        var map = window.MC2_HEAD_ICONS || {};
        if (heads.length < 2) {
          iconWrap.hidden = true;
        } else {
          heads.forEach(function (h) {
            var btn = document.createElement("button");
            btn.type = "button";
            btn.className = "mc2-product-tabs__filter-pill mc2-product-tabs__filter-pill--head";
            btn.setAttribute("data-mc2-facet", "headtype");
            btn.setAttribute("data-mc2-value", h);
            btn.setAttribute("aria-pressed", "false");
            btn.setAttribute("aria-label", h);
            btn.title = h;
            var url = map[mc2HeadKey(h)]; // CL-0086: same translated-value fold as the card icon
            if (url) {
              var img = document.createElement("img");
              img.src = url; img.alt = ""; img.width = 28; img.height = 28;
              btn.appendChild(img);
            } else {
              btn.textContent = h;
            }
            host.appendChild(btn);
          });
          iconWrap.hidden = false;
        }
      }
    }
  }

  function initFilter(row) {
    var panel = row.closest(".mc2-product-tabs__tabpanel");
    if (!panel) return;
    var grid = panel.querySelector(".mc2-product-tabs__grid");
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-mc2-card]"));
    buildControls(row, cards); // CL-0063: build dropdowns + head icons from the cards

    var pills = Array.prototype.slice.call(row.querySelectorAll(".mc2-product-tabs__filter-pill"));
    var dropdowns = Array.prototype.slice.call(row.querySelectorAll("[data-mc2-dropdown]"));
    var clearBtn = row.querySelector("[data-mc2-filter-clear]");
    var emptyEl = row.querySelector("[data-mc2-filter-empty]");
    var countEl = row.querySelector("[data-mc2-filter-count]"); // CL-0068
    var stockToggle = row.querySelector("[data-mc2-instock-toggle]"); // CL-0057
    var metricToggle = row.querySelector("[data-mc2-metric-toggle]"); // CL-0076
    var metricWrap = row.querySelector("[data-mc2-metric-wrap]"); // CL-0076
    var hideMetricToggle = row.querySelector("[data-mc2-hidemetric-toggle]"); // CL-0083
    var hideMetricWrap = row.querySelector("[data-mc2-hidemetric-wrap]"); // CL-0083
    // CL-0076/CL-0083: show the metric toggles only when this tab has metric products.
    if (metricWrap || hideMetricWrap) {
      var hasMetric = false;
      cards.forEach(function (c) { if (c.getAttribute("data-mc2-metric") === "1") hasMetric = true; });
      if (metricWrap) metricWrap.hidden = !hasMetric;
      if (hideMetricWrap) hideMetricWrap.hidden = !hasMetric;
    }
    var sortSelect = row.querySelector("[data-mc2-sort]"); // CL-0054
    var originalOrder = cards.slice(); // CL-0054: DOM order as rendered, for "Featured"

    function selectionByFacet() {
      var map = {};
      pills.forEach(function (p) {
        if (p.getAttribute("aria-pressed") === "true") {
          var f = p.getAttribute("data-mc2-facet");
          (map[f] = map[f] || []).push(p.getAttribute("data-mc2-value"));
        }
      });
      dropdowns.forEach(function (d) { // CL-0063: single-select dropdown facets
        if (d.value) {
          var df = d.getAttribute("data-mc2-dropdown");
          (map[df] = map[df] || []).push(d.value);
        }
      });
      return map;
    }

    function cardMatches(card, sel, inStockOnly, metricOnly, hideMetric) {
      if (inStockOnly && card.getAttribute("data-mc2-instock") !== "1") return false; // CL-0057
      if (metricOnly && card.getAttribute("data-mc2-metric") !== "1") return false; // CL-0076
      if (hideMetric && card.getAttribute("data-mc2-metric") === "1") return false; // CL-0083
      for (var facet in sel) {
        if (!Object.prototype.hasOwnProperty.call(sel, facet)) continue;
        var attr = (inStockOnly && MC2_FACET_ATTR_INSTOCK[facet]) ? MC2_FACET_ATTR_INSTOCK[facet] : MC2_FACET_ATTR[facet];
        if (!attr) continue;
        var raw = card.getAttribute(attr) || "";
        var vals = raw ? raw.split("|") : [];
        var hit = false;
        for (var i = 0; i < vals.length; i++) {
          if (sel[facet].indexOf(vals[i]) !== -1) { hit = true; break; }
        }
        if (!hit) return false; // AND across facets; OR within a facet
      }
      return true;
    }

    // CL-0058 / CL-0065: when a variant-option facet (colour or head type) is active, switch each
    // matching card's corresponding <select> to a chosen value so the tile shows THAT variant
    // (image / price / stock / add-to-cart), not the alphabetical default. Colour has per-value
    // stock data so it can prefer an in-stock value; head type has none, so the card's own update()
    // reflects OOS for the resulting combo.
    var MC2_OPT_POS = { color: "data-color-position", headtype: "data-headtype-position", posttype: "data-posttype-position" };
    var MC2_OPT_HAVE = { color: "data-mc2-color", headtype: "data-mc2-headtype", posttype: "data-mc2-posttype" };
    var MC2_OPT_STOCK = { color: "data-mc2-color-instock" };
    function setCardOption(card, facet, values, inStockOnly) {
      var posAttr = MC2_OPT_POS[facet];
      if (!posAttr) return;
      var pos = parseInt(card.getAttribute(posAttr), 10);
      if (!pos) return;
      var have = (card.getAttribute(MC2_OPT_HAVE[facet]) || "").split("|");
      var stockAttr = MC2_OPT_STOCK[facet];
      var haveStock = stockAttr ? (card.getAttribute(stockAttr) || "").split("|") : [];
      var pick = null, i;
      if (inStockOnly && stockAttr) {
        for (i = 0; i < values.length && !pick; i++) { if (haveStock.indexOf(values[i]) !== -1) pick = values[i]; }
      }
      if (!pick) for (i = 0; i < values.length && !pick; i++) { if (have.indexOf(values[i]) !== -1) pick = values[i]; }
      if (!pick) return;
      var sc = card.querySelector('select[data-option-position="' + pos + '"]');
      if (sc && sc.value !== pick) { sc.value = pick; sc.dispatchEvent(new Event("change", { bubbles: true })); }
    }

    function apply() {
      var sel = selectionByFacet();
      var anySel = false;
      for (var k in sel) { if (Object.prototype.hasOwnProperty.call(sel, k)) { anySel = true; break; } }
      var inStockOnly = stockToggle ? stockToggle.checked : false; // CL-0057
      var metricOnly = metricToggle ? metricToggle.checked : false; // CL-0076
      var hideMetric = hideMetricToggle ? hideMetricToggle.checked : false; // CL-0083
      var shown = 0;
      cards.forEach(function (card) {
        var ok = cardMatches(card, sel, inStockOnly, metricOnly, hideMetric);
        card.hidden = !ok;
      if (ok) {
          shown++;
          if (sel.color && sel.color.length) setCardOption(card, "color", sel.color, inStockOnly); // CL-0058
          if (sel.headtype && sel.headtype.length) setCardOption(card, "headtype", sel.headtype, inStockOnly); // CL-0065
          if (sel.posttype && sel.posttype.length) setCardOption(card, "posttype", sel.posttype, inStockOnly); // CL-0073
        }
      });
      if (clearBtn) clearBtn.hidden = !anySel;
      if (emptyEl) emptyEl.hidden = !((anySel || inStockOnly || metricOnly || hideMetric) && shown === 0);
      if (countEl) countEl.textContent = shown + (MC2_IS_FR ? (shown === 1 ? " produit" : " produits") : (shown === 1 ? " product" : " products")); // CL-0068 / CL-0087 FR count
      if (sortSelect && sortSelect.value) sortCards(sortSelect.value); // CL-0054: keep sort after filter/colour change
    }

    function reset() {
      pills.forEach(function (p) { p.setAttribute("aria-pressed", "false"); });
      dropdowns.forEach(function (d) { d.value = ""; }); // CL-0063
      apply();
    }

    // CL-0054: client-side sort. Reorders every card in the grid; hidden (filtered) cards keep their
    // hidden state, so sort and filter compose. "" (Featured) restores the original rendered order.
    function numAttr(el, name) { var v = parseFloat(el.getAttribute(name)); return isNaN(v) ? Infinity : v; }
    function nameOf(el) { var t = el.querySelector(".mc2-product-tabs__card-title"); return (t ? t.textContent : "").trim().toLowerCase(); }
    // CL-0054: price of the variant the tile is currently showing (respects the colour filter selection),
    // so price sort matches what's on screen instead of the product's minimum price.
    function cardPriceCents(card) {
      var s = card.querySelector("script[data-mc2-variants]");
      var vs = [];
      try { vs = JSON.parse(s.textContent); } catch (e) { vs = []; }
      if (!vs.length) return numAttr(card, "data-mc2-sort-price");
      var selects = card.querySelectorAll("select[data-option-position]");
      if (selects.length) {
        var chosen = {};
        Array.prototype.forEach.call(selects, function (sl) { chosen[parseInt(sl.getAttribute("data-option-position"), 10)] = sl.value; });
        for (var i = 0; i < vs.length; i++) {
          var ok = true;
          for (var pos in chosen) { if (vs[i].options[pos - 1] !== chosen[pos]) { ok = false; break; } }
          if (ok && typeof vs[i].pricec === "number") return vs[i].pricec;
        }
      }
      for (var m = 0; m < vs.length; m++) { if (vs[m].available && typeof vs[m].pricec === "number") return vs[m].pricec; }
      return (typeof vs[0].pricec === "number") ? vs[0].pricec : numAttr(card, "data-mc2-sort-price");
    }
    function sortCards(mode) {
      var arr;
      if (!mode) {
        arr = originalOrder.slice();
      } else {
        arr = cards.slice();
        arr.sort(function (a, b) {
          if (mode === "name-asc") return nameOf(a).localeCompare(nameOf(b));
          // CL-0078: length sorts keep cards without a length value last in BOTH directions.
          if (mode.indexOf("length") === 0) {
            var la = numAttr(a, "data-mc2-sort-length"), lb = numAttr(b, "data-mc2-sort-length");
            if (la === Infinity || lb === Infinity) { return la === lb ? 0 : (la === Infinity ? 1 : -1); }
            return mode.indexOf("-desc") !== -1 ? lb - la : la - lb;
          }
          var d = cardPriceCents(a) - cardPriceCents(b);
          return mode.indexOf("-desc") !== -1 ? -d : d;
        });
      }
      var frag = document.createDocumentFragment();
      arr.forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
    }

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        var pressed = pill.getAttribute("aria-pressed") === "true";
        pill.setAttribute("aria-pressed", pressed ? "false" : "true");
        apply();
      });
    });
    dropdowns.forEach(function (d) { d.addEventListener("change", apply); }); // CL-0063
    if (clearBtn) clearBtn.addEventListener("click", reset);
    if (stockToggle) stockToggle.addEventListener("change", apply); // CL-0057
    if (metricToggle) metricToggle.addEventListener("change", function () { // CL-0076
      if (metricToggle.checked && hideMetricToggle) hideMetricToggle.checked = false; // CL-0083: mutually exclusive
      apply();
    });
    if (hideMetricToggle) hideMetricToggle.addEventListener("change", function () { // CL-0083
      if (hideMetricToggle.checked && metricToggle) metricToggle.checked = false;
      apply();
    });
    if (sortSelect) sortSelect.addEventListener("change", function () { sortCards(sortSelect.value); }); // CL-0054

    var root = row.closest(".mc2-product-tabs");
    if (root) root.addEventListener("mc2:tabchange", reset);

    apply();
  }

  /* ---------------- lazy card hydration (CL-0040) ---------------- */
  function initCardsLazy() {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-mc2-card]"));
    if (!("IntersectionObserver" in window)) { cards.forEach(initCard); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { obs.unobserve(e.target); initCard(e.target); }
      });
    }, { rootMargin: "600px 0px" });
    cards.forEach(function (c) { io.observe(c); });
  }

  function init() {
    initCardsLazy();
    document.querySelectorAll("[data-mc2-tabs]").forEach(initTabs);
    document.querySelectorAll("[data-mc2-filter]").forEach(initFilter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();